import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

import StyledButton from '../styledComponents/StyledButton';
import CustomButton from '../button/CustomButton';

import getCroppedImg from './CropImage';

const ImageCropper = ({
  imageData = '',
  editingDone,
  size,
  cancelPopup,
  showCropperModal1,
}) => {
  const [crop, setCrop] = useState({
    x: 0,
    y: 0,
  });

  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageData?.file,
        croppedAreaPixels,
        rotation,
      );
      //

      getBase64FromLocalBlobUrl(croppedImage)
        .then((base64String) => {
          // Use the base64String as needed
          editingDone({ file: base64String });
        })
        .catch(() => {});

      // Simply Print the Base64 Encoded String,
      // without additional data: Attributes.
    } catch (e) {}
  }, [croppedAreaPixels, rotation]);

  function getBase64FromLocalBlobUrl(blobUrl) {
    return new Promise((resolve, reject) => {
      fetch(blobUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();

          reader.onloadend = function () {
            const base64String = reader.result.split(',')[1];

            if (base64String.includes('data:image/png;base64')) {
              resolve(base64String);
            } else {
              resolve(`data:image/png;base64,${base64String}`);
            }
          };

          reader.readAsDataURL(blob);
        })
        .catch(() => {
          reject(new Error('Error occurred while fetching Blob data.'));
        });
    });
  }

  return (
    <>
      <Modal show={showCropperModal1} size="xl">
        <Modal.Body className="overflow-auto">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Cropper
              image={imageData?.file}
              crop={crop}
              rotation={rotation}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              zoom={zoom}
              onZoomChange={setZoom}
              cropSize={{
                width:
                  imageData.width > size.width ? size.width : imageData.width,
                height:
                  imageData.height > size.height
                    ? size.height
                    : imageData.height,
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <BtnOutlineDefault onClick={cancelPopup}> Cancel </BtnOutlineDefault>
          <StyledButton onClick={showCroppedImage}> Done </StyledButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const BtnOutlineDefault = styled(CustomButton)`
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.mainPrimary};
  color: ${({ theme }) => theme.mainPrimary};
  padding: 8px 12px;
  height: 48px;
  border-radius: 8px;
  font-size: 14px;
  &:hover,
  &:focus,
  &:active {
    background-color: ${({ theme }) => theme.white} !important;
    color: ${({ theme }) => theme.mainPrimary} !important;
    border-color: ${({ theme }) => theme.mainPrimary} !important;
  }
`;

export default ImageCropper;
